




import { Component, Ref, Prop, Watch, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ace, { Ace } from 'ace-builds'
import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/mode-json5'

@Component
export default class AtomAce extends ComponentVue {
  @Ref()
  ace!: Element

  @Prop({ type: String })
  value!: string

  @Prop({ type: String, default: '50vh' })
  height!: string

  editor!: Ace.Editor

  get style(): object {
    return {
      height: this.height
    }
  }

  @Watch('value', { immediate: true })
  onChangeValue() {
    if (this.editor && this.editor.getValue() !== this.value) {
      this.editor.setValue(this.value)
    }
  }

  mounted() {
    this.editor = ace.edit(this.ace)
    this.editor.setFontSize('15px')
    this.editor.session.setMode('ace/mode/json5')
    this.editor.on('change', this.onInput)
  }

  destroyed() {
    this.editor.off('change', this.onInput)
    this.editor.destroy()
    this.editor.container.remove()
  }

  @Emit('input')
  onInput() {
    console.log('AtomAce', 'onInput')
    return this.editor.getValue()
  }
}
